import { tv, type VariantProps } from "tailwind-variants";

export const sectionHeaderVariant = tv({
  slots: {
    wrapper: ["flex", "items-center", "gap-3"],
    title: ["max-w-166", "text-text-neutral-default"],
    subtitle: ["max-w-166", "text-text-neutral-default"],
    description: ["max-w-166", "text-text-neutral-soft"],
    linkIcon: [],
  },
  variants: {
    appearance: {
      primary: {
        subtitle: ["my-3"],
        linkIcon: ["w-6", "h-6", "text-text-neutral-softer"],
      },
      secondary: {
        linkIcon: ["hidden"],
      },
    },
  },
  defaultVariants: {
    appearance: "primary",
  },
});

export type SectionHeaderVariantProps = VariantProps<typeof sectionHeaderVariant>;
export type SectionHeaderReturnVariantProps = ReturnType<typeof sectionHeaderVariant>;
